import React, {
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState,
} from 'react'
import PropTypes from 'prop-types'

const MagnetCustomerListingStoreBridgeContext = React.createContext({
  isRegistered: false,
  listingStoreId: undefined,
  onStoreFilterChange: null,
  register: () => {},
  unregister: () => {},
})

export const useMagnetCustomerListingStoreBridge = () =>
  useContext(MagnetCustomerListingStoreBridgeContext)

export const MagnetCustomerListingStoreBridgeProvider = ({ children }) => {
  const [registration, setRegistration] = useState(null)
  const onStoreFilterChangeRef = useRef(null)

  const register = useCallback(({ storeId, onStoreFilterChange }) => {
    onStoreFilterChangeRef.current = onStoreFilterChange
    setRegistration({ storeId })
  }, [])

  const unregister = useCallback(() => {
    onStoreFilterChangeRef.current = null
    setRegistration(null)
  }, [])

  const onStoreFilterChange = useCallback((storeId) => {
    onStoreFilterChangeRef.current?.(storeId)
  }, [])

  const value = useMemo(
    () => ({
      isRegistered: registration != null,
      listingStoreId: registration?.storeId,
      onStoreFilterChange,
      register,
      unregister,
    }),
    [registration, onStoreFilterChange, register, unregister]
  )

  return (
    <MagnetCustomerListingStoreBridgeContext.Provider value={value}>
      {children}
    </MagnetCustomerListingStoreBridgeContext.Provider>
  )
}

MagnetCustomerListingStoreBridgeProvider.propTypes = {
  children: PropTypes.node.isRequired,
}
